import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
import { ConfigType } from '../data-config';
import { SecurityTracing } from './securityTracing';
import { BanInformation } from '../ban-information';
export var SubmissionActivity = /*#__PURE__*/function (_Entity) {
  _inherits(SubmissionActivity, _Entity);

  var _super = _createSuper(SubmissionActivity);

  function SubmissionActivity() {
    _classCallCheck(this, SubmissionActivity);

    return _super.apply(this, arguments);
  }

  _createClass(SubmissionActivity, [{
    key: "securityTracings",
    get: function get() {
      return this.props.securityTracings;
    }
  }, {
    key: "banInformation",
    get: function get() {
      return this.props.banInformation;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(status) {
      this.props.status = status;
      return Result.ok();
    }
  }, {
    key: "isStatusSatisfied",
    value: function isStatusSatisfied(status) {
      return this.props.status.id === status;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.status,
        argumentName: 'Submission Status'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      var submissionActivity = new SubmissionActivity(props, new UniqueEntityID(props.id));
      return Result.ok(submissionActivity);
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var id = data.id,
            status = data.status,
            securityTracings = data.securityTracings,
            banInformation = data.banInformation;
        var statusProps = ConfigType.create({
          id: status.id,
          name: status.name
        }).getValue();
        var securityTracingsProps = securityTracings && securityTracings.length !== 0 ? securityTracings.map(function (securityTracing) {
          return SecurityTracing.create(_objectSpread({}, securityTracing)).getValue();
        }) : null;
        var banInformationProps = banInformation ? BanInformation.create(_objectSpread({}, banInformation)).getValue() : null;
        var props = {
          id: id,
          status: statusProps,
          securityTracings: securityTracingsProps,
          banInformation: banInformationProps
        };
        return this.create(props);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return SubmissionActivity;
}(Entity);